export const MIN_HOURS_PER_WEEK = 3;
export const MAX_HOURS_PER_WEEK = 19;
